import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoOdepem from '../assets/logoodepem.jpeg';
import logoInversiones from '../assets/WhatsApp Image 2026-05-19 at 4.17.16 PM (3).jpeg';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">

            {/* BRAND */}
            <div className="footer-brand">
              <div className="footer-logo">
                <img src={logoOdepem} alt="JM ODEPEM" className="footer-logo-img" />
                <div>
                  <div className="footer-logo-name">JM ODEPEM</div>
                  <div className="footer-logo-sub">Financiera S.R.L.</div>
                </div>
              </div>
              <p className="footer-tagline">
                Nos ajustamos a tu necesidad. Tu aliado financiero de confianza en República Dominicana.
              </p>
              <div className="footer-social">
                <a href="https://www.facebook.com/people/Financiera-JM-Odepem-SRL/61555922236420" target="_blank" rel="noreferrer" className="footer-social-icon">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="https://www.instagram.com/jmodepem/" target="_blank" rel="noreferrer" className="footer-social-icon">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a href="https://www.tiktok.com/@financierajmodepem" target="_blank" rel="noreferrer" className="footer-social-icon">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.67a8.18 8.18 0 004.77 1.52V6.73a4.85 4.85 0 01-1-.04z"/>
                  </svg>
                </a>
                <a href="https://wa.me/18098227417" target="_blank" rel="noreferrer" className="footer-social-icon whatsapp">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* NAVEGACIÓN */}
            <div className="footer-col">
              <h4>Navegación</h4>
              <ul>
                <li><Link to="/">Inicio</Link></li>
                <li><Link to="/sobre-nosotros">Sobre Nosotros</Link></li>
                <li><Link to="/servicios">Nuestros Servicios</Link></li>
                <li><Link to="/jm-inversiones">Inversiones JM</Link></li>
                <li><Link to="/contacto">Contáctanos</Link></li>
              </ul>
            </div>

            {/* SERVICIOS */}
            <div className="footer-col">
              <h4>Servicios</h4>
              <ul>
                <li><Link to="/servicios">Préstamos Personales</Link></li>
                <li><Link to="/servicios">Préstamos Generales</Link></li>
                <li><Link to="/servicios">Préstamos PYME</Link></li>
                <li><Link to="/servicios">Préstamos Hipotecarios</Link></li>
                <li><Link to="/servicios">Línea de Crédito Superior</Link></li>
                <li><Link to="/servicios">Financiamiento Generales</Link></li>
              </ul>
            </div>

            {/* CONTACTO DOBLE */}
            <div className="footer-col footer-col-contacto">

              {/* JM ODEPEM */}
              <div className="footer-company-header">
                <h4 className="footer-JM-title">JM ODEPEM FINANCIERA S.R.L.</h4>
              </div>
              <ul className="footer-contact">
                <li>
                  <span className="footer-contact-icon">📍</span>
                  <span>Calle Independencia #61, Moca, Espaillat</span>
                </li>
                <li>
                  <span className="footer-contact-icon">📞</span>
                  <a href="tel:+18099881906">809-988-1906</a>
                </li>
                <li>
                  <span className="footer-contact-icon">📞</span>
                  <a href="tel:+18297131098">829-713-1098</a>
                </li>
                <li>
                  <span className="footer-contact-icon">✉️</span>
                  <a href="mailto:info@jmodepem.com">info@jmodepem.com</a>
                </li>
                <li>
                  <span className="footer-contact-icon">🕐</span>
                  <div>
                    <strong>Horario</strong>
                    <p>Lunes — Viernes: 8:30 AM – 6:00 PM</p>
                    <p>Sábados: 8:30 AM – 4:00 PM</p>
                  </div>
                </li>
              </ul>

              {/* JM INVERSIONES */}
              <div className="footer-inversiones" style={{ marginTop: '24px' }}>
                <div className="footer-inversiones-logo">
                  <img src={logoInversiones} alt="JM Inversiones" className="footer-inv-img" />
                  <div>
                    <span className="footer-inv-name">INVERSIONES JM</span>
                    <span className="footer-inv-sub">MEJÍA SANTOS S.R.L.</span>
                  </div>
                </div>

                <ul className="footer-contact">
                  <li>
                    <span className="footer-contact-icon">📍</span>
                    <span>Calle Sánchez esq. Sabana Larga, Moca (Ext. 1016)</span>
                  </li>
                  <li>
                    <span className="footer-contact-icon">📍</span>
                    <span>Calle Real No. 60, Carretera Tamboril, Santiago (Ext. 1017)</span>
                  </li>
                  <li>
                    <span className="footer-contact-icon">📱</span>
                    <span><a href="tel:+18099359178">809-935-9178</a> (Moca)</span>
                  </li>
                  <li>
                    <span className="footer-contact-icon">📱</span>
                    <span><a href="tel:+18297571049">829-757-1049</a> (Tamboril)</span>
                  </li>
                </ul>

                <div className="footer-social" style={{ marginTop: '12px' }}>
                  <a href="https://www.instagram.com/inversiones_jm_s/" target="_blank" rel="noreferrer" className="footer-social-icon">
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </a>
                  <a href="https://wa.me/18099359178" target="_blank" rel="noreferrer" className="footer-social-icon whatsapp">
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                    </svg>
                  </a>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>© 2026 Financiera JM ODEPEM S.R.L. — Todos los derechos reservados.</p>
          <p>Desarrollado por <span>Jenifer Reyes Pérez</span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;